export default __webpack_public_path__ + "images/166322bceeddee1517704dadd69aa221-emoji-excited.svg";